"use strict";

import {requestListBookmarks, requestSetBookmark} from "../libs/apiv2-requests";
import {AuthModal} from "../libs/auth";
import restrictedAuth from "../libs/restrictedAuth";
import docready from "../libs/docready";
import {GroupsListFilter} from "../libs/filters/groupsListFilter";

async function getter() {
    if (!getter.promise) {
        getter.promise = requestListBookmarks()
    }
    return getter.promise
}

const setter = function () {
    if (user.isGuest) {
        if (community.is_approved_members_only) {
            restrictedAuth()
        } else {
            const modal = new AuthModal()
            modal.gid = $(this).data('id') || window.gid
            modal.authenticate('bookmark', '', 'bookmarks')
        }
    } else {
        const $this = $(this)
        requestSetBookmark($this.data('id') || window.gid, $this.toggleClass('selected').hasClass('selected'))
            .then(() => syncElementWithBookmarksList($this.closest('li')))
    }
    return false
}

const syncElementWithBookmarksList = function ($element) {
    const bookmarkedContainer = $('#BookmarkedItemsContainer ul')
    if ($element.find('.bookmark-wrapper .selected').length) {
        docready($element.clone(false).appendTo(bookmarkedContainer))

    } else {
        const key = $element.data('key')
        bookmarkedContainer.find(`[data-key=${key}]`).remove()
        $(`#panel__regular-groups li[data-key=${key}] .bookmark-button`).removeClass('selected')
    }
}

export default async context => {
    const list = $('.bookmark-button', context)
    if (list.length) {
        list.on('click', setter)
        if (!context.closest('#BookmarkedItemsContainer').length) {
            const selected = await getter()
            const bookmarkedContainer = $('#BookmarkedItemsContainer ul')
            list.removeClass('selected')
                .filter((i, em) => selected.includes(parseInt(em.getAttribute('data-id'))))
                .addClass('selected')
                .closest('li')
                .each(function () {
                    const $this = $(this)
                    const data = JSON.parse($this.attr('data-tags'))
                    data.push('_bookmark')
                    $this.data('tags', data)
                    $this.attr('data-tags', JSON.stringify(data))
                    if (data.includes('_regular')) {
                        docready($this.clone(false).appendTo(bookmarkedContainer))
                    }
                    const filter = $this.closest('.filter-container')
                    if (filter.data('filter') instanceof GroupsListFilter) {
                        filter.data('filter').promiseUpdate()
                    }
                })
        }
    }
    $('.bookmark-activity-button', context)
        .each(async function () {
            const selected = await getter()
            if (selected.includes(window.gid)) {
                $(this).addClass('selected')
            } else {
                $(this).removeClass('selected')
            }
        })
        .on('click', setter)
}
